export default {"src":"/_next/static/media/advantages-icon-2.9b5388d3.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};